import { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styles from './styles.module.scss';
import StudioEditor from '@grapesjs/studio-sdk/react';
import '@grapesjs/studio-sdk/style';
import { registerHandlebarsBlocks } from './utils';
import {
  STARTER_TEMPLATE,
  initialCustomData,
} from 'pages/Dashboard/Kits/components/KitsTemplate/helpers';

export type KitsTemplateModel = {
  html: string;
  css: string;
  templateMeta: {
    projectJSON: any;
  };
};

interface KitsTemplateEditorProps {
  value: KitsTemplateModel;
}

const KitsTemplateEditor = forwardRef<any, KitsTemplateEditorProps>(({ value }, ref) => {
  const editorRef = useRef<any>(null);

  // @TODO: remove this after testing
  // check from query params if emptyKitTemplate is true
  const isEmpty = new URLSearchParams(window.location.search).get('emptyKitTemplate') === 'true';

  useImperativeHandle(ref, () => ({
    getTemplateData: async () => {
      if (!editorRef.current) return null;
      const html = editorRef.current.getHtml();
      const css = editorRef.current.getCss();
      const projectJSON = await editorRef.current.store();
      return { html, css, templateMeta: { projectJSON } };
    },
  }));

  const getSafeHTml = (html: string) => {
    return html.replace(/&(?!(amp|lt|gt|quot|apos|#\d+);)/g, '&amp;');
  };

  const handleEditorReady = (studio) => {
    editorRef.current = studio.editor;
    if (value?.html) {
      editorRef.current.setComponents(getSafeHTml(value.html));
    } else if (value?.templateMeta?.projectJSON) {
      editorRef.current.loadProject(value.templateMeta.projectJSON);
    } else {
      editorRef.current.setComponents(isEmpty ? '' : STARTER_TEMPLATE);
    }
  };

  return (
    <StudioEditor
      onReady={handleEditorReady}
      options={{
        licenseKey: process.env.REACT_APP_GRAPEJS_LICENSE_KEY,
        project: {
          type: 'email',
          id: `kit-template`,
        },
        i18n: {
          locales: {
            en: {
              actions: {
                importCode: {
                  content: 'Paste here your MJML code and click Import',
                },
              },
            },
          },
        },
        identity: {
          id: 'user-1',
        },
        assets: {
          storageType: 'self',
        },
        storage: {
          type: 'self',
        },
        customData: initialCustomData,
        plugins: [registerHandlebarsBlocks],
        onDestroy: () => {
          editorRef.current = null;
        },
      }}
    />
  );
});

export default KitsTemplateEditor;
